module.exports = __webpack_public_path__ + "img/logo_rasgosobresaliente.1bafa09e.png";